import { type MemoExoticComponent, memo, type ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { PARSE_DURATION_BASE_UNITS, parseDuration } from '@didaskill/utils/misc';

import { VARIANTS } from './constants';
import messages from './FormattedDuration.messages';

export type FormattedDurationProps = {
  /** Give the duration in minutes. */
  value?: number;
  /** Variant. */
  variant?: VARIANTS;
  /** Base unit time */
  unit?: PARSE_DURATION_BASE_UNITS;
  /** Render function */
  render?: (timeValues: ReturnType<typeof parseDuration>) => ReactNode;
};

export const FormattedDurationBase = ({
  value = 0,
  variant = VARIANTS.SHORT,
  unit = PARSE_DURATION_BASE_UNITS.MINUTE,
  render = undefined,
}: FormattedDurationProps) => {
  const timeValues = useMemo(() => parseDuration(value, unit), [value, unit]);

  return !render ? (
    <FormattedMessage {...messages[variant]} values={timeValues} />
  ) : (
    render(timeValues)
  );
};

FormattedDurationBase.displayName = 'FormatDuration';

export const FormattedDuration: MemoExoticComponent<typeof FormattedDurationBase> & {
  VARIANTS?: typeof VARIANTS;
  UNITS?: typeof parseDuration.BASE_UNITS;
} = memo(FormattedDurationBase);
FormattedDuration.VARIANTS = VARIANTS;
FormattedDuration.UNITS = parseDuration.BASE_UNITS;
